import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DetailsQueries } from '../../queries/details.queries';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { VehicleOptionsMetaData, OptionsAccessoriesComponent } from 'remarketing-ui-components-lib';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-equipment-accessories',
    templateUrl: './equipment-accessories.component.html',
    styleUrls: ['./equipment-accessories.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, OptionsAccessoriesComponent, CommonModule]
})
export class EquipmentAccessoriesComponent {
  @Input() variant;
  @Select(DetailsQueries.equipmentAccessories) options$: Observable<VehicleOptionsMetaData>;
  @Select(DetailsQueries.equipmentLongDescriptions) longDescriptions$: string[];

  maxEquipRows = 4;
  translatedData: any;
  constructor(private readonly translocoService: TranslocoService) {
    this.translocoService.selectTranslateObject('UIComponents.optionAccessories').subscribe(translatedObj => {
      this.translatedData = translatedObj;
    });
  }
}
